import axios from "axios";
import { alert as showAlert } from "../components/common/Alert";
import { ALERT_LEVEL } from "../constants";

let isInterceptorSetup = false;

/**
 * Axios 전역 인터셉터 설정
 * - 401/403 에러 발생 시 사용자에게 명확한 메시지 표시
 * - 토큰 만료 시 로그아웃 유도
 */
export const setupAxiosInterceptors = (setAuth, history, t) => {
  // 중복 설정 방지
  if (isInterceptorSetup) {
    return;
  }

  // Response 인터셉터 추가
  axios.interceptors.response.use(
    (response) => {
      // 정상 응답은 그대로 반환
      return response;
    },
    (error) => {
      // 에러 응답 처리
      if (error.response) {
        const { status } = error.response;

        // 401 Unauthorized: 토큰이 유효하지 않음
        if (status === 401) {
          console.error('[Auth] 401 Unauthorized - 토큰이 만료되었거나 유효하지 않습니다.');

          // 사용자에게 알림
          showAlert(
            t ? t("Session expired. Please login again.") : "세션이 만료되었습니다. 다시 로그인해주세요.",
            ALERT_LEVEL.WARNING
          );

          // 로그아웃 처리
          if (setAuth) {
            setAuth(null);
            sessionStorage.clear();
            localStorage.removeItem("auth"); // Remember me 저장된 토큰도 제거
          }

          // 로그인 페이지로 이동
          if (history) {
            setTimeout(() => {
              history.push("/signIn");
            }, 2000); // 2초 후 이동 (사용자가 알림을 읽을 시간)
          }
        }
        // 403 Forbidden: 토큰이 없거나 권한이 없음
        else if (status === 403) {
          console.error('[Auth] 403 Forbidden - 인증 토큰이 없거나 권한이 부족합니다.');

          const errorMessage = error.response.data?.message || "";

          // "No token" 메시지인 경우
          if (errorMessage.includes("No token")) {
            showAlert(
              t ? t("Authentication required. Please login.") : "인증이 필요합니다. 로그인해주세요.",
              ALERT_LEVEL.WARNING
            );

            // 로그아웃 처리
            if (setAuth) {
              setAuth(null);
              sessionStorage.clear();
              localStorage.removeItem("auth");
            }

            // 로그인 페이지로 이동
            if (history) {
              setTimeout(() => {
                history.push("/signIn");
              }, 2000);
            }
          }
          // 권한 부족인 경우
          else {
            showAlert(
              t ? t("Access denied. You don't have permission.") : "접근 권한이 없습니다.",
              ALERT_LEVEL.DANGER
            );
          }
        }
      }

      // 에러를 다시 throw해서 개별 .catch()에서도 처리 가능하게 함
      return Promise.reject(error);
    }
  );

  isInterceptorSetup = true;
  console.log('[Auth] Axios 인터셉터 설정 완료');
};
